import { Expandable } from '@AMIEWEB/Common';
import React, { createRef, useState } from 'react';
import { Title } from 'app/components/Order/OrderDetails/OrderPreferences/customComponents/OrderPreferencesDesign';
import { LibraryBooksOutlined } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { FormProvider, useForm } from 'react-hook-form';
import { gridStateActions } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import { revalidateChipSelection } from '@AMIEWEB/GlobalSearch/helper';
import SearchGridWrapper from 'app/layout/pages/SearchGridWrapper';
import { selectGridState } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.selectors';
import { PlacementHistoryFilters } from '../PlacementHistory/PlacementHistoryFilters';
import PlacementHistoryGrid from '../PlacementHistory/PlacementHistoryGrid';
import { defaultPlacementHistoryFilters } from '../PlacementHistory/PlacementHistoryFilterUtils';
import { FilterSearchChips } from '@AMIEWEB/GlobalSearch/Common/FilterSearchChips';

const PlacementHistory = ({ 
  onModsDetailsClick
}: { 
  onModsDetailsClick: any;
}) => {
  const formMethods = useForm({ defaultValues: defaultPlacementHistoryFilters });
  const { handleSubmit } = formMethods;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { filterAttributes } = useSelector(selectGridState);
  const hiddenSubmitButton = createRef<HTMLButtonElement>();
  const [resetGridParams, setResetGridParams] = useState<boolean>(false);
  const onApplyFilter = (values, newSelectionChips?) => {
    const selectedChipFilters =
      newSelectionChips || revalidateChipSelection(values, filterAttributes?.selectedChipFilters || []);

    dispatch(
      gridStateActions.setFilterAttributes({
        ...filterAttributes,
        filterObject: Object.entries(values),
        selectedChipFilters,
      }),
    );
  };

  return (
    <React.Fragment>
      <Expandable
        expanded
        unmountOnExit={false}
        titleComponent={
          <Title>
            <LibraryBooksOutlined style={{ marginRight: '5px' }} />
            {t('placement.placementHistory.containerTitle')}
          </Title>
        }
      >
        <div style={{ margin: '-12px -12px 8px -12px', padding: '0' }}>
          <FormProvider {...formMethods}>
            <form onSubmit={handleSubmit(filter => onApplyFilter(filter))}>
              <SearchGridWrapper
                filters={
                  <PlacementHistoryFilters onApplyFilter={onApplyFilter} setResetGridParams={setResetGridParams} />
                }
                table={
                  <PlacementHistoryGrid
                    resetGridParams={resetGridParams}
                    setResetGridParams={setResetGridParams}
                    onModsDetailsClick={onModsDetailsClick}
                  />
                }
                chips={<FilterSearchChips onApplyFilter={onApplyFilter} />}
                loading={false}
              />
              <button ref={hiddenSubmitButton} style={{ display: 'none' }} type="submit" />
            </form>
          </FormProvider>
        </div>
      </Expandable>
    </React.Fragment>
  );
};

export default PlacementHistory;
